import React, { Component, useState, useRef } from 'react';
import './App.css';
import 'react-tooltip/dist/react-tooltip.css'

import styled from 'styled-components'
import { useTable, useSortBy, useFilters, useGlobalFilter, usePagination } from 'react-table'
// A great library for fuzzy filtering/sorting items
import matchSorter from 'match-sorter'

import axios from "axios";

import MyNavbar from './MyNavbar';
import HighlightModal from './Modal.js';
import Welcome from "./Welcome";
import Definition from "./Definition.js";
import Comments from "./Comments.js";
import Impressum from "./Impressum.js";
import Datenschutz from "./Datenschutz.js";
import Error404 from "./Error404.js";
import { urlSafe } from './helpers';
import { COLORS } from './Colors.js'

import { BrowserRouter, Routes, Route, useParams, Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";

import ReactGA from "react-ga4";

import Joyride, { ACTIONS } from 'react-joyride';

import { initReactI18next, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import i18n_de from './i18n/de.js';
import i18n_en from './i18n/en.js';

import Select from 'react-select';
import Footer from './Footer.js';
import ScrollToTop from "./ScrollToTop.js";
import StyledInput from "./StyledInput.js"
import AnalyticsTracker from "./AnalyticsTracker";
import Pagination from "./Pagination.js";
import SelectColumnFilter from './SelectColumnFilter.js';

import CategoryList from "./CategoryList.js";
import CategoryListExtended from "./CategoryListExtended.js";
import CategoryListExtended2 from "./CategoryListExtended2.js";
import SumList from "./SumList.js"
import NameList from "./NameList.js"
import Download from "./Download.js"

import { setupAxiosInterceptors } from './interceptor.js';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }

    th {
      vertical-align: bottom;
    }

    th span {
      background-color: transparent;
      color: white;
    }

    th span.title {
      text-transform: uppercase;
      margin-bottom: 1rem;
      display: inline-block;
    }

    thead > tr:nth-child(1) > th {
      background-color: var(--fire);
    }

    thead > tr:nth-child(2) > th,
    tfoot > tr > th {
      background-color: black;
    }

    th > div,
    th > div > div {
      background-color: transparent
    }

    th > div > div > div:nth-child(3) > div > div:nth-child(2) {
       background-color: unset;
    }

    tbody > tr:nth-child(even) > td {
      background-color: #f0f0f0; /* Light grey */
    }    
  }
`

// Translations.
i18n.use(initReactI18next).init({
  resources: {
    de: i18n_de,
    en: i18n_en,
  },
  fallbackLng: 'de', // TODO change back to en
  interpolation: { escapeValue: false },
});


setupAxiosInterceptors()

// Wrapper component for Modal that does the hooks for search and navigate
function HighlightModalWrapper(props) {
  const { Route_Highlight, lang } = useParams();  // Access the URL parameter

  var eventId = -1
  if (props.events != null && Route_Highlight != null) {
    props.events.forEach(event => {
      if (event.Beschreibung === null) {
        console.log("Beschreibung null for:")
        console.log(event)
      }
      else if (urlSafe(event.Beschreibung) === urlSafe(Route_Highlight)) {
        eventId = event.eventId
      }
    })
  }

  var show = (eventId >= 0) ? true : false
  const navigate = useNavigate(); // Get the navigate function
  const location = useLocation(); // Get the location object
  const cleanPath = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
  var listPath = cleanPath.substring(0, cleanPath.lastIndexOf('/'));
  const basePath = listPath.substring(0, listPath.lastIndexOf('/'));
  return <HighlightModal {...props} eventId={eventId} show={show} navigate={navigate} lang={lang} basePath={basePath} listPath={listPath} />;
}

function CookieWrapper(props) {
  const { lang } = useParams();
  const GAinitialized = useRef(false);
  const isFirstRender = useRef(true);

  React.useEffect(() => {
    if (lang === undefined)
      return;

    if (window.UC_UI && window.UC_UI.isInitialized()) {
      window.UC_UI.updateLanguage(lang)
    } else {
      setTimeout(() => {
        window.UC_UI.updateLanguage(lang)
      }, 3000);
    }
  }, [lang]);

  const initGA = () => {
    if (window.UC_UI && window.UC_UI.isInitialized()) {
      window.UC_UI.getServicesBaseInfo().forEach(service => {
        if (service.id === "87JYasXPF" && service.consent.status) {
          if (GAinitialized.current === false) {
            ReactGA.initialize("G-FSF3T5W6VH");
            console.log("GA init");
            GAinitialized.current = true;
          }
        }
      })
    }
  }

  const hideUCFloater = () => {
    let ucButton = document.querySelector("#usercentrics-root");
    if (ucButton && ucButton.shadowRoot) {
      ucButton = ucButton.shadowRoot.querySelector('[data-testid="uc-privacy-button"]');
    }
    if (ucButton) {
      console.log("UC found")
      ucButton.style.display = "none";
      return true;
    } else {
      console.log("UC not found")
      return false;
    }
  }

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;  // Mark first render as complete

      window.addEventListener('UC_UI_CMP_EVENT', initGA);
      setTimeout(() => {
        initGA();
      }, 3000);

      if (hideUCFloater() === false) {
        console.log("UC: Adding timer");
        setTimeout(() => {
          hideUCFloater();
        }, 3000);
      }
    }
  }, []);

  return <></>
}

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  // const count = preFilteredRows.length
  const { t } = useTranslation();

  return (
    <StyledInput
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      // placeholder={`${count} records...`}
      placeholder={t('texts.list.search')}
    />
  )
}

function SelectColumnFilterSplit({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  const { t } = useTranslation();

  const [selectedOption, setSelectedOption] = useState({ value: "", label: t('texts.list.all') });

  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      if (row.values[id] != null)
        row.values[id].split(" | ").forEach(elem => {
          options.add(elem)
        })
    })
    return Array.from(options).sort(function (a, b) { return a.localeCompare(b) })
  }, [id, preFilteredRows])

  var selectOptions = [{ value: "", label: t('texts.list.all') }]
  options.forEach((option, i) => {
    selectOptions.push({ value: option, label: option })
  })

  return (
    <Select
      value={selectedOption}
      onChange={e => {
        setFilter(e.value || undefined)
        setSelectedOption(e)
      }}
      options={selectOptions}
    />
  )
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val

function JoyrideWrapper(props) {
  const { Route_Highlight } = useParams();  // Access the URL parameter
  const { t } = useTranslation();

  if (Route_Highlight != null)
    return "";

  return <Joyride
    steps={t('joyride.steps', { returnObjects: true })}
    callback={props.handleJoyrideCallback}
    run={true}
    continuous={true}
    showProgress={false}
    showSkipButton={false}
    locale={t('joyride.nav', { returnObjects: true })}
    styles={{
      options: {
        primaryColor: '#333',
      },
    }}
  />
}

var gTable;

function setTable(table) {
  gTable = table;
}

// Our table component
function Table({ columns, data, showTour }) {

  const { lang } = useParams();
  const { t, i18n } = useTranslation();

  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
      kategorie: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          if (rowValue === undefined)
            return true;
          var decision = false;
          String(rowValue).split(" | ").forEach(elem => { if (elem === String(filterValue)) decision = true; });
          return decision;
        })
      },
    }),
    []
  )

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
      // width: "auto",
    }),
    []
  )

  var initialState = { pageIndex: 0, hiddenColumns: ["eventId"] };

  const [searchParams] = useSearchParams();
  var WEL_Nr = searchParams.get("WEL_Nr");

  if (WEL_Nr != null) {
    initialState['filters'] = [{ id: "Welterbe", value: WEL_Nr }];
  }

  var table = useTable(
    {
      columns,
      data,
      defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes,
      initialState,
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    usePagination,
    // useBlockLayout
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page, // Instead of using 'rows', we'll use page,
    prepareRow,
    preGlobalFilteredRows
  } = table;

  setTable(table);

  return (
    <>
      <table {...getTableProps({ style: { width: "100%" } })} id="worldlist_table">
        <thead>
          {headerGroups.map(headerGroup => {
            const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} {...headerGroupProps}>
                {headerGroup.headers.map(column => {
                  const { key, ...headerProps } = column.getHeaderProps();
                  return (
                    <th key={key} {...headerProps} className={'table-header-' + column.id}>
                      <span className="title" {...column.getSortByToggleProps()}>{column.render('Header')}</span>
                      {/* Add a sort direction indicator */}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? ' 🔽'
                            : ' 🔼'
                          : ''}
                      </span>
                      {/* Render the columns filter UI */}
                      <div>{column.canFilter ? column.render('Filter') : null}</div>
                    </th>
                  );
                })}
              </tr>
            );
          }
          )}
          <Pagination table={table} t={t} showTour={showTour} />
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            const { key, ...rowProps } = row.getRowProps();
            return (
              <tr key={key} {...rowProps}>
                {row.cells.map(cell => {
                  const { key, ...cellProps } = cell.getCellProps();
                  return <td key={key} {...cellProps}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          {preGlobalFilteredRows.length > 0 && <Pagination table={table} t={t} showTour={showTour} />}
        </tfoot>
      </table >
    </>
  )
}

function navigateURL(id, direction) {
  if (id < 0)
    return ""
  if (!gTable)
    return ""

  var currentEntry = 0
  var obj = gTable.rows

  while (currentEntry < obj.length && obj[currentEntry].values.eventId !== Number(id))
    currentEntry++;
  if (currentEntry === obj.length) // not found
    return ""
  currentEntry += direction;
  if (currentEntry >= obj.length)
    currentEntry = obj.length - 1
  if (currentEntry < 0)
    currentEntry = 0
  var url = "/" + urlSafe(obj[currentEntry].values.Beschreibung)
  return url
}

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
  return rows.filter(row => {
    const rowValue = row.values[id]
    return rowValue >= filterValue
  })
}

// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number
filterGreaterThan.autoRemove = val => typeof val !== 'number'

class App extends Component {
  state = {
    events: [],
    showJoyride: false, // NOTE put this to false to not start joyride tour by default
  };

  getTableColumns() {
    return [
      {
        Header: 'Id',
        accessor: 'eventId',
        show: false,
      },
      {
        Header: this.props.t('texts.list.kontinent'),
        accessor: 'Kontinent',
        width: 100,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.land'),
        accessor: 'Land',
        width: 100,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.region'),
        accessor: 'LandRegion',
        width: 100,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.gruppe'),
        accessor: (row) => {
          if (row.MHL === 1)
            return "Mega";
          if (row.HL === 1)
            return "Top";
          return "Standard";
        },
        width: 80,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.title'),
        // accessor: (row) => { return <a href="#" onClick={() => this.highlight(row.eventId)}>{row.Beschreibung}</a>; },
        accessor: 'Beschreibung',
        Cell: ({ row }) => (<Link className="table-link" to={urlSafe(row.original.Beschreibung)}>{row.original.Beschreibung}</Link>),
        midWidth: 200,
        width: 300,
        maxWidth: 500,
      },
      {
        Header: this.props.t('texts.list.kategorien'),
        //accessor: 'Kategorie1',
        Filter: SelectColumnFilterSplit,
        filter: 'kategorie',
        accessor: (row) => {
          var tmp = row.Kategorie1;
          if (row.Kategorie2 != null)
            tmp += " | " + row.Kategorie2;
          if (row.Kategorie3 != null)
            tmp += " | " + row.Kategorie3;
          if (row.Kategorie4 != null)
            tmp += " | " + row.Kategorie4;
          return tmp;
        },
      },
    ];
  }

  getTableColumnsUnesco() {
    return [
      {
        Header: 'Id',
        accessor: 'eventId',
        show: false,
      },
      {
        Header: this.props.t('texts.list.land'),
        accessor: 'Land',
        width: 100,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.region'),
        accessor: 'LandRegion',
        width: 100,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.gruppe'),
        accessor: (row) => {
          if (row.MHL === 1)
            return "Mega";
          if (row.HL === 1)
            return "Top";
          return "Standard";
        },
        width: 80,
        Filter: SelectColumnFilter,
      },
      {
        Header: this.props.t('texts.list.welterbe'),
        id: 'Welterbe',
        accessor: (row) => { return row.WEL_Name + " (Nr. " + row.WEL_Nr + ")"; },
      },
      {
        Header: this.props.t('texts.list.title'),
        accessor: 'Beschreibung',
        Cell: ({ row }) => (<Link to={urlSafe(row.original.Beschreibung)} style={{ backgroundColor: "transparent" }}>{row.original.Beschreibung}</Link>),
        midWidth: 200,
        width: 300,
        maxWidth: 500,
      },
      {
        Header: this.props.t('texts.list.kategorien'),
        //accessor: 'Kategorie1',
        Filter: SelectColumnFilterSplit,
        accessor: (row) => {
          var tmp = row.Kategorie1;
          if (row.Kategorie2 != null)
            tmp += " | " + row.Kategorie2;
          if (row.Kategorie3 != null)
            tmp += " | " + row.Kategorie3;
          if (row.Kategorie4 != null)
            tmp += " | " + row.Kategorie4;
          return tmp;
        },
      },
    ]
  }

  loadData() {
    var url = `${process.env.REACT_APP_DATA_HOST}/${this.props.params.lang}/events`
    if (process.env.NODE_ENV === 'development')
      url += "_short";
    axios.get(url)
      .then(res => {
        const events = res.data.data;
        // console.log(events);
        this.setState({ events });
      })
  }

  componentDidMount() {
    this.loadData();
    if (document.cookie.split('; ').find((row) => row.startsWith('joyride=')))
      this.setState(({ showJoyride: false }));
  }

  componentDidUpdate(prevProps) {
    // Check if the specific prop has changed
    if (prevProps.params.lang !== this.props.params.lang) {
      this.loadData();
    }
  }

  handleJoyrideCallback = data => {
    if (data.action === ACTIONS.CLOSE || data.action === ACTIONS.RESET) {
      // Set cookie to not show Joyride again
      document.cookie = 'joyride=false; max-age=31536000; path=/';
      this.setState({ showJoyride: false });
    }
  }

  showTour = () => {
    this.setState({ showJoyride: true });
  }

  // TODO go to Router > v6.4, then move to createBrowserRouter and use loader for the data in the modal
  // Possibly use useNavigation but one needs a different router then?

  render() {
    return (
      <>
        <MyNavbar />
        <ScrollToTop />
        <CookieWrapper />
        <Routes>
          <Route index element={<Welcome />} />
          <Route path="worldlist/:Route_Highlight?" element={<>
            <Definition currentPage='list' sectionColor={COLORS[2]} button_target={this.showTour}>
              <HighlightModalWrapper events={this.state.events} navigateURL={navigateURL} checkingMode={false} />
              <Styles>
                <Table columns={this.getTableColumns()} data={this.state.events} showTour={this.showTour} />
                <div style={{ height: "2rem" }}></div>
              </Styles>
              {this.state.showJoyride && <JoyrideWrapper handleJoyrideCallback={this.handleJoyrideCallback} />}
            </Definition>
          </>} />
          <Route path="unescolist/:Route_Highlight?" element={<>
            <HighlightModalWrapper events={this.state.events} navigateURL={navigateURL} checkingMode={false} />
            <Styles>
              <Table columns={this.getTableColumnsUnesco()} data={this.state.events} />
            </Styles>
          </>} />
          <Route path="book" element={<Definition currentPage='book' sectionColor={COLORS[7]} />} />
          <Route path="definition" element={<Definition currentPage='definition' sectionColor={COLORS[1]} />} />
          <Route path="about" element={<Definition currentPage='about' sectionColor={COLORS[5]} />} />
          <Route path="concept" element={<Definition currentPage='concept' sectionColor={COLORS[4]} />} />
          <Route path="travels" element={<Definition currentPage='travels' sectionColor={COLORS[6]} />} />
          <Route path="worldmodel" element={<Definition currentPage='model' sectionColor={COLORS[3]} />} />
          <Route path="comments" element={<Comments />} />
          <Route path="impressum" element={<Impressum />} />
          <Route path="datenschutz" element={<Datenschutz />} />
          <Route path="category_list" element={<CategoryList />} />
          <Route path="worldmodel_rankings" element={<CategoryListExtended />} />
          <Route path="worldmodel_extremes" element={<CategoryListExtended2 />} />
          <Route path="sum_list" element={<SumList />} />
          <Route path="name_list" element={<NameList />} />
          <Route path="worldlist_excel" element={<Download />} />
          {/* 404 fallback for undefined routes */}
          <Route path="*" element={<Error404 />} />  {/* ONLY WORKS FOR PATHS LIKE /de/abc OR en/def, NOT JUST /abc SO FAR!!!*/}
        </Routes>
        <Footer />
      </>
    );
  }
}
// 

// Functional wrapper to extract and pass params to a class component
const AppWrapper = (props) => {
  const { lang } = useParams();
  const { t, i18n } = useTranslation();

  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
  }, [lang, i18n]);

  const params = useParams();

  return <App {...props} t={t} params={params} />;
};

function RedirectToDefaultLanguage() {
  const navigate = useNavigate();

  var browserLang = (navigator.language || navigator.userLanguage).split('-')[0];
  if (browserLang !== "en" && browserLang !== "de")
    browserLang = "en"
  // console.log(browserLang)

  React.useEffect(() => {
    // console.log("Redirecting to /de"); // this WILL run
    navigate("/" + browserLang, { replace: true });
  }, [navigate, browserLang]);

  return null; // or a loading spinner
}

function Root(props) {
  return <BrowserRouter>
    <AnalyticsTracker />
    <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<RedirectToDefaultLanguage />} />
      {/* Main App routes with language handling */}
      <Route path="/:lang/*" element={<AppWrapper />} />
    </Routes>
  </BrowserRouter>
}

export default Root;
